import React from "react";

import { templates } from "@reactivated";

import { ProductCompareGridSSR } from "../apps/product-compare/ProductCompareGridSSR";

export const Template = (
    props: templates.ProductCompareGridBlockTemplate,
): React.JSX.Element => <ProductCompareGridSSR {...props} />;
